import { useAuth } from "../context/AuthContext";
import React, { Fragment, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import AxisSpinner from "./AxisSpinner";
import UserSelection from "./UserSelection";
import DateTimePicker from "react-datetime-picker";
import { ButtonModalOnClickClose } from "./ButtonModalSelection";

export const AvailabilityEditType = ({
  pageHeaderMsg,
  forceUpdate,
  availabilityObject,
  close = null,
  hideModalActions = false,
}) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [isEarly, setIsEarly] = useState(availabilityObject?.early);
  const [isLate, setIsLate] = useState(availabilityObject?.late);
  const [isLongDay, setIsLongDay] = useState(availabilityObject?.longday);
  const [isTwilight, setIsTwilight] = useState(availabilityObject?.twilight);
  const [isNight, setIsNight] = useState(availabilityObject?.night);
  const [isEvening, setIsEvening] = useState(availabilityObject?.evening);

  useEffect(() => {
    setIsEarly(availabilityObject?.early);
    setIsLate(availabilityObject?.late);
    setIsLongDay(availabilityObject?.longday);
    setIsTwilight(availabilityObject?.twilight);
    setIsNight(availabilityObject?.night);
    setIsEvening(availabilityObject?.evening);
  }, [availabilityObject]);

  const onToggle = async (e, type) => {
    e.preventDefault();
    var params = {};

    params["type"] = type;
    params["user_id"] = availabilityObject?.user?.id;
    params["date"] = availabilityObject?.date;
    try {
      setLoading(true);
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };
      const response = await authAxios().post(
        "/api/backoffice/availability/edit",
        {},
        config,
      );
      console.log("onToggle", e);
      console.log("type", type);
      if (type === "LATE") setIsLate(!e.target.checked);
      if (type === "NIGHT") setIsNight(!e.target.checked);
      if (type === "TWILIGHT") setIsTwilight(!e.target.checked);
      if (type === "EARLY") setIsEarly(!e.target.checked);
      if (type === "LONGDAY") setIsLongDay(!e.target.checked);
      if (type === "EVENING") setIsEvening(!e.target.checked);
      forceUpdate();
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const deleteAll = async (type) => {
    var params = {};
    params["user_id"] = availabilityObject?.user?.id;
    params["date"] = availabilityObject?.date;

    setLoading(true);
    for (const type of ["EARLY", "LATE", "LONGDAY", "TWILIGHT", "NIGHT", "EVENING"]) {
      params["type"] = type;
      if (type === "EARLY" && !isEarly) continue;
      if (type === "LATE" && !isLate) continue;
      if (type === "LONGDAY" && !isLongDay) continue;
      if (type === "TWILIGHT" && !isTwilight) continue;
      if (type === "NIGHT" && !isNight) continue;
      if (type === "EVENING" && !isEvening) continue;
      try {
        const config = {
          headers: {
            "content-type": "application/json",
          },
          params: params,
        };
        const response = await authAxios().post(
          "/api/backoffice/availability/edit",
          {},
          config,
        );
      } catch (e) {
        console.log(e);
      }
    }
    setLoading(false);
  };

  const deleteAllAvailability = () => {
    deleteAll().then((response) => {
      forceUpdate();
      if (close !== null) close(false);
    });
  };

  return (
    <Fragment>
      <Container fluid>
        <Row className="mb-4 align-items-center">
          <Form.Group as={Col} controlId={"formUser"}>
            <Form.Control
              as={UserSelection}
              defaultValue={availabilityObject?.user}
              disabled={true}
            />
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Control
              as={DateTimePicker}
              format={"dd/MM/yyyy"}
              value={availabilityObject?.date}
              disabled
            />
          </Form.Group>
        </Row>
        <Form className={"m-0 p-0"}>
          <Form.Check
            className={"fs-3"}
            type="checkbox"
            checked={isEarly}
            onChange={(e) => {
              onToggle(e, "EARLY");
            }}
            label={"Early"}
          />
          <Form.Check
            className={"fs-3"}
            type="checkbox"
            checked={isLate}
            onChange={(e) => {
              onToggle(e, "LATE");
            }}
            label={"Late"}
          />
          <Form.Check
            className={"fs-3"}
            type="checkbox"
            checked={isLongDay}
            onChange={(e) => {
              onToggle(e, "LONGDAY");
            }}
            label={"Long Day"}
          />
          <Form.Check
            className={"fs-3"}
            type="checkbox"
            checked={isTwilight}
            onChange={(e) => {
              onToggle(e, "TWILIGHT");
            }}
            label={"Twilight"}
          />
          <Form.Check
            className={"fs-3"}
            type="checkbox"
            checked={isNight}
            onChange={(e) => {
              onToggle(e, "NIGHT");
              setIsNight(!isNight);
            }}
            label={"Night"}
          />
          <Form.Check
            className={"fs-3"}
            type="checkbox"
            checked={isEvening}
            onChange={(e) => {
              onToggle(e, "EVENING");
            }}
            label={"Evening"}
          />
        </Form>
      </Container>
      <AxisSpinner loading={loading} />

      {!hideModalActions && (
        <ButtonModalOnClickClose
          funcButtonName={"Delete"}
          close={close}
          loading={loading}
          onClickFunc={deleteAllAvailability}
        />
      )}
      {hideModalActions && (
        <div className={"mt-3"}>
          <Button
            variant={"outline-danger"}
            onClick={deleteAllAvailability}
            disabled={loading}
          >
            Delete
          </Button>
        </div>
      )}
    </Fragment>
  );
};
